export function uploadFilesReducer(action) {
    let byId = {};
    const allIds = [];
    Array.from(action.payload.files).forEach(fileInfo => {
        const id = fileInfo.id;
        byId = Object.assign(Object.assign({}, byId), { [id]: fileInfo });
        allIds.push(id);
    });
    return { byId: byId, allIds: allIds };
}
//# sourceMappingURL=uploadFilesReducer.js.map